import { useState } from "react";
import ColorPicker from "src/components/ColorPicker";
import { css } from "@emotion/react";
import CustomizedButton from "@/modules/ui-elements/CustomizedButton";
import { updateJobBatchEditor } from "src/modules/editor-v2/services/Jobs";
import { useSelector } from "react-redux";
import useAuth from "src/hooks/useAuth";

const DOMAIN=process.env.NEXT_PUBLIC_WEBSITE_REDIRECTION
const style = {
    btnStyle: {
        flexGrow: 1,
        gap: "5px",
        padding: "10px"
    },
    title: css`
        font-family: Objectivity;
        font-size: 16px;
        font-weight: 500;
        line-height: 26px;
        letter-spacing: 0em;
        text-align: left;
        padding: 10px;
        `,
    colorPicker: css`
        padding: 10px;
    `,
    btnContainer:
    { 
        display: "flex", 
        flexDirection: "row", 
        justifyContent: "space-between", 
        gap: "5px", 
        padding:"10px" 
    },
    colorContainer(color) {
        return {
            width: "24px",
            height: "24px",
            backgroundColor: color,
            padding: "10px",
            borderRadius: "4px",
            border: "1px solid #EEEEEE",
        };
    },
    colorContainer2:
    { display: "flex", flexWrap: "wrap", gap: "10px",padding: "5px" }
}
export default function ColorAdjustment(props) {

    const [loading, setLoading] = useState(false);
    const [background, setBackground] = useState("#FFFFFF");
    const colors = ["#FFFFFF", "#FF0000", "#127E44", "#0500FF"];
    const {entireStrapiData} = useSelector((state)=> state.strapi)
    const strapiData = entireStrapiData?.WebsiteWidget?.WebsiteWidget;
    const { user} = useAuth();
    const sourceEntityId = user?.user?.entities?.[0]?.entityId;

    const changeBackground = (data) =>{
        setBackground(data?.toUpperCase())
    }
    const onColorUpdate = async () => {
        setLoading(true)
        const customDetails = {
            size: {
                height: 1500,
                width: 1500
            },
            coverage: 80,
            position: "centre",
            backgroundColor: background
        };
        try {
            const result = await updateJobBatchEditor(props?.jobId, customDetails);
          } catch (error) {
            console.error('Error during API call:', error);
          }
        setLoading(false)
        if(!sourceEntityId) return;
        window.top.location.href=`${DOMAIN}/${props?.jobId}?Change-Background-Color&sourceEntityId=${sourceEntityId}`;
        localStorage.removeItem('disableInterceptor');
    };
    return (
        <div style={{pointerEvents: loading ? 'none' : 'auto'}}>
            <div css={style.title}>{strapiData?.SelectColor || "Select a Color"}</div>
            <div style={style.colorContainer2}>
                {colors.map((color, index) => (
                    <div
                        key={index}
                        style={style.colorContainer(color)}
                        onClick={() =>changeBackground(color)}
                    />
                ))}
            </div>
            <div css={style.colorPicker}><ColorPicker defaultValue={background} onChange={changeBackground} /></div>

            <div style={style.btnContainer}>

                <CustomizedButton
                    type={"grey"}
                    isActive={true}
                    btnText={strapiData?.Back || "Back"}
                    btnStyle={style.btnStyle}
                    onClick={props?.onCancel}
                />
                <CustomizedButton
                    type={"pink_with_border"}
                    isActive={true}
                    btnText={strapiData?.Next || "Next"}
                    btnStyle={style.btnStyle}
                    onClick={onColorUpdate}
                    disabled={loading}
                    isLoading={loading}
                />
            </div>
        </div>

    )
}